export const deptColor = (dept = "") => {
  const map = {
    engineering: { bg: "rgba(99,102,241,0.12)", text: "#818cf8", border: "rgba(99,102,241,0.25)" },
    design: { bg: "rgba(236,72,153,0.12)", text: "#f472b6", border: "rgba(236,72,153,0.25)" },
    marketing: { bg: "rgba(245,158,11,0.12)", text: "#fbbf24", border: "rgba(245,158,11,0.25)" },
    finance: { bg: "rgba(16,185,129,0.12)", text: "#34d399", border: "rgba(16,185,129,0.25)" },
    another: { bg: "rgba(168,85,247,0.12)", text: "#c084fc", border: "rgba(168,85,247,0.25)" },
  };
  return map[dept.toLowerCase()] || { bg: "rgba(148,163,184,0.12)", text: "#94a3b8", border: "rgba(148,163,184,0.25)" };
};

export const formatSalary = (min, max) => {
  const fmt = (n) => {
    const num = parseFloat(n);
    if (num >= 100000) return `${(num / 100000).toFixed(1)}L`;
    if (num >= 1000) return `${(num / 1000).toFixed(0)}K`;
    return `${num}`;
  };
  return `${fmt(min)} – ${fmt(max)}`;
};

export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
